export default __webpack_public_path__ + "static/media/investor-16.af77749e.png";